import React from "react";
import { Result, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

const Cancel = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const orderCode = params.get("orderCode");

  return (
    <Result
      status="error"
      title="Thanh toán thất bại hoặc bị hủy!"
      subTitle={`Mã đơn hàng: ${orderCode}`}
      extra={[
        <Button type="primary" key="home" onClick={() => navigate("/")}>
          Về trang chủ
        </Button>,
      ]}
    />
  );
};

export default Cancel;